import * as React from 'react';
import {Reviews} from 'sections/services-marketplace/experts/sections/profile/components';
import GetProfileReviewsQuery from '../graphql/GetProfileReviewsQuery.graphql';
import {
  getServicesMarketplacePublicClient,
  Connection,
} from 'utilities/graphql';
import {notifyException} from 'utilities/analytics/bugsnag';
import {RouteComponentProps, withRouter} from 'react-router';
import {Metrics, Review, ReviewFilters} from 'sections/types';
import {serviceHandleFromSlug} from 'sections/services-marketplace/experts/utilities/taxonomy';

const client = getServicesMarketplacePublicClient();

interface Profile {
  serviceListing: {
    reviews: Connection<Review>;
    serviceMetrics: Metrics;
  };
}

interface State {
  profile?: Profile;
  filters?: ReviewFilters;
  loading: boolean;
}

type CombinedProps = {} & RouteComponentProps<{
  expertSlug: string;
  serviceSlug: string;
}>;

class ReviewsContainer extends React.Component<CombinedProps, State> {
  state: State = {
    loading: false,
  };

  onReviewRatingClick = (filters: ReviewFilters) => {
    this.setState({filters}, this.fetchProfiles);
  };

  componentDidMount() {
    this.fetchProfiles();
  }

  componentDidUpdate(prevProps: Readonly<CombinedProps>) {
    if (
      this.props.match.params.serviceSlug !== prevProps.match.params.serviceSlug
    ) {
      this.fetchProfiles();
    }
  }

  fetchProfiles() {
    this.setState({
      loading: true,
    });

    client
      .query<{profile: Profile}>({
        query: GetProfileReviewsQuery,
        variables: {
          serviceHandle: serviceHandleFromSlug(
            this.props.match.params.serviceSlug
          ),
          handle: this.props.match.params.expertSlug,
          before: this.state.filters && this.state.filters.before,
          after: this.state.filters && this.state.filters.after,
          ratings: this.state.filters && [this.state.filters.rating],
        },
      })
      .then(res => {
        const profile = res.data.profile;
        this.setState({profile, loading: false});
      })
      .catch(error => {
        notifyException({error});
      });
  }

  render() {
    const {filters, profile, loading} = this.state;
    if (!profile) return null;

    const {
      serviceListing: {reviews, serviceMetrics},
    } = profile;

    return (
      <Reviews
        currentServiceHandle={serviceHandleFromSlug(
          this.props.match.params.serviceSlug
        )}
        filteredRating={filters && filters.rating}
        onReviewRatingClick={this.onReviewRatingClick}
        reviews={reviews}
        metrics={serviceMetrics}
        loading={loading}
      />
    );
  }
}

export default withRouter(ReviewsContainer);
